<template>
  <div class="overlay" v-if="$store.getters.hasPopupWithInput">
    <div class="overlay_inner success">
        <p class="field">
          <text-input id="input"
              v-model="inputText"
              name="input"
              ref="inputref"
              size="30">
            {{ $gettext($store.getters.getPopupWithInputMessage) }}
          </text-input>
        </p>

        <p class="buttons">
          <a class="btn" :title="$store.getters.getPopupWithInputSubmitButtonText | translate" @click.stop.prevent="submitPopup">{{ $gettext($store.getters.getPopupWithInputSubmitButtonText) }}</a>
        </p>

        <a class="btn btn_action btn_close" :title="'Zavřít' | translate" @click.stop.prevent="closePopup" v-translate>Zavřít</a>
    </div>
  </div>
</template>

<script>

import formFields from "@/components/mixins/form-fields"
import detailActions from "@/components/mixins/detail-actions"
import {HIDE_POPUP_WITH_INPUT} from "../../store/mutation-types";

export default {
  name: "PopupWithInput",
  components: {},
  mixins: [formFields, detailActions],
  props: {
    messageParams: Object,
    required: {
        type: Boolean,
        default: true
    }
  },
  data: function () {
    return {
      inputText: ''
    }
  },
  methods: {
    closePopup() {
        this.$store.commit(HIDE_POPUP_WITH_INPUT);
    },
    submitPopup() {
        if (this.required && this.inputText === '') {
            this.$refs.inputref.setForcedInvalid(true);
            return;
        }

        this.$emit('submitAction', this.$store.getters.getPopupWithInputAction, this.inputText, this.$store.getters.getPopupWithInputData);
        this.inputText = null;
        this.closePopup();
    }
  },
  watch: {
      '$store.getters.hasPopupWithInput' (newShow, oldShow) {
          if (newShow && !oldShow && this.$store.getters.getPopupWithInputDefaultInputValue) {
              this.inputText = this.$store.getters.getPopupWithInputDefaultInputValue;
          }
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/PopupWithInput.vue